// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3AG66","row":"styles_row__2dvP2"};